import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import {
  type BearingFrequencyCalculationParams,
  type BearingFrequencyCalculationResult,
} from "~/pages/BearingFrequencyCalculatorPage/utils/calculateBearingFrequency";
import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";

interface Props
  extends Pick<BearingFrequencyCalculationParams, "isInch" | "isDeg">,
    Record<keyof Omit<BearingFrequencyCalculationParams, "isInch" | "isDeg">, string>,
    Record<keyof Omit<BearingFrequencyCalculationResult, "isInch" | "isDeg">, string> {}

export const downloadBearingFrequencyPdf = async (props: Props) => {
  const response = await occFetch(occUrl("/bearing-frequency-calculator/calculator-result/pdf"), {
    body: JSON.stringify(props),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  await downloadBlobFromResponse(response);
};
